/**
 * Created by intellicar-rinas on 21/10/17.
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import "./InGraph.css";
import * as d3 from "d3";
import moment from "moment";

class InGraph extends Component {
  state = {
    busy: false,
  };

  data = { 0: [], 1: [] };
  pointerLineX = 0;

  constructor(props) {
    super(props);
    this.divRef = React.createRef(); 

    this.uid = "graph-" + parseInt(Math.random() * 1000, 10);

    this.dataStat = {};

    this.draw = this.draw.bind(this);

    this.brushHandler = (data) => {
      if (!this.active) return;

      if (!data || !data.e) return;
      let event = data.e;

      //brush
      if (event.sourceEvent && event.sourceEvent.type === "zoom") return; // ignore brush-by-zoom
      let sDummy = event.selection || this.x2.range();

      let s = [
        this.width * (sDummy[0] / data.width),
        this.width * (sDummy[1] / data.width),
      ];
      this.selection = s;
      this.x.domain(s.map(this.x2.invert, this.x2));
      if (this.focus && this.focus.select) {
        this.focus.select(".area").attr("d", this.area);
        this.focus.select(".area2").attr("d", this.areaY2);
        this.focus.select(".axis--x").call(this.xAxis);
      }
      this.Context.select(".brush").call(this.brush.move, s);
      this.svg
        .select(".zoom")
        .call(
          this.zoom.transform,
          d3.zoomIdentity.scale(this.width / (s[1] - s[0])).translate(-s[0], 0)
        );

      this.checkDataReq();
    };

    this.zoomHandler = (data) => {
      if (!this.active) return;

      if (!data || !data.e) return;
      let event = data.e;

      //zooming
      let t = event.transform;
      let trans = this.x
        .range()
        .map(t.invertX, { ...t, x: this.width * (t.x / data.width) });
      this.selection = trans;
      this.x.domain(t.rescaleX(this.x2).domain());
      if (this.focus && this.focus.select) {
        this.focus.select(".area").attr("d", this.area);
        this.focus.select(".area2").attr("d", this.areaY2);
        this.focus.select(".axis--x").call(this.xAxis);
      }
      this.Context.select(".brush").call(this.brush.move, trans);

      //handle syncing
      if (data.uid !== this.uid) {
        this.svg
          .select(".zoom")
          .call(
            this.zoom.transform,
            d3.zoomIdentity
              .scale(this.width / (trans[1] - trans[0]))
              .translate(-trans[0], 0)
          );
      }
      this.checkDataReq();
    };

    this.checkDataReq = () => {
      if (this.props.config.type === "controller") {
        if (
          this.selection[1] - this.selection[0] < this.width / 5 &&
          !this.newDataReq
        ) {
          this.newDataReq = true;
          console.log(
            "requesting new data!",
            this.x.invert(this.selection[0]),
            this.x.invert(this.selection[1])
          );
        }
      }
    };

    this.mouseOverHandler = (data) => {
      for (let index in this.props.data.config) {
        let sourceWidth = data.selection[1] - data.selection[0];
        let sourceLeft = (data.selection[0] * this.width) / data.width;

        this.pointerLineX = (data.x * this.width) / data.width;
        if (
          this.props.config.type !== "controller" &&
          data.source === "controller"
        ) {
          this.pointerLineX =
            ((this.pointerLineX - sourceLeft) * data.width) / sourceWidth;
        } else if (
          this.props.config.type === "controller" &&
          data.source !== "controller"
        ) {
          this.pointerLineX =
            (this.pointerLineX * sourceWidth) / data.width + sourceLeft;
        }

        if (isNaN(this.pointerLineX)) return;

        let bisect = d3.bisector(function (d) {
          return d.time;
        }).right;
        let item =
          this.data[index][
            bisect(this.data[index], this.x.invert(this.pointerLineX))
          ];
        if (this.pointerLine) {
          this.pointerLine.attr("x", this.pointerLineX);
        }
        if (item) {
          if (this["pointerText" + index]) {
            this["pointerText" + index].text(
              this.props.data.config[index].name +
                " : " +
                parseFloat(
                  (item.value ? item.value : 0.0).toFixed(2),
                  10
                ).toFixed(2) +
                " " +
                (this.props.data.config[index].unit
                  ? this.props.data.config[index].unit
                  : "")
            );
          }
          if (this["timeText" + index]) {
            this["timeText" + index].text(
              moment(this.x.invert(this.pointerLineX)).format(
                "D MMM YYYY | HH:mm:ss"
              )
            );
          }
        }
        if (this.props.data.controller && data.broadcast) {
          if (window.updateTimeline) {
            window.updateTimeline(moment(data.time).unix() * 1000);
          }
        }
      }
    };

    this.setBusy = (status) => {
      this.setState({ busy: status });
    };

    this.init = this.init.bind(this);

    this.getStroke = (index = 0) => {
      if (this.props.data.config[index].gradient) {
        return "url(#pathgrad)";
      }
      return this.props.data.config[index].color || "#44ff69";
    };

    window.addGraphListener("zoom", this.zoomHandler);
    window.addGraphListener("brush", this.brushHandler);
    window.addGraphListener("mouseover", this.mouseOverHandler);
  }

  componentWillUnmount() {
    window.clearGraphListener();
  }

  init(svg) {
    this.svg = d3.select(svg);
    this.margin = {
      top: 20,
      right: this.props.data.config.length > 1 ? 45 : 20,
      bottom: 20,
      left: 40,
    };
    this.margin2 = { top: 1, right: 1, bottom: 25, left: 1 };

    if (this.props.data.staticHandler) {
      this.margin = this.margin2 = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      };
    }

    this.width = this.props.config.width - this.margin.left - this.margin.right;
    let height = this.svg.attr("height");
    if (isNaN(height)) {
      height = this.props.config.height;
    }
    this.height = +height - this.margin.top - this.margin.bottom;
    this.height2 = +height - this.margin2.top - this.margin2.bottom;

    this.x = d3.scaleTime().range([0, this.width]);
    this.x2 = d3.scaleTime().range([0, this.width]);
    this.y = d3.scaleLinear().range([this.height, 0]);
    this.ya2 = d3.scaleLinear().range([this.height, 0]);
    this.y2 = d3.scaleLinear().range([this.height2, 0]);

    const getTickValues = (d) => {
      if (d > 9990) {
        return parseInt(d / 1000, 10) + "k";
      } else if (d > 999) {
        return (d / 1000).toFixed(1) + "k";
      }
      return d;
    };

    this.xAxis = d3.axisBottom(this.x).ticks(3);
    this.xAxis2 = d3.axisBottom(this.x2);
    this.yAxis = d3.axisLeft(this.y).ticks(5).tickFormat(getTickValues);
    this.yAxis2 = d3.axisRight(this.ya2).ticks(5).tickFormat(getTickValues);

    const zoomTrigger = () => {
      if (!this.active) return;
      //   if (d3.event.sourceEvent && d3.event.sourceEvent.type === "brush") return; // ignore zoom-by-brush
      //   if (
      //     !d3.event.sourceEvent ||
      //     this.zoomEventTime === d3.event.sourceEvent.timeStamp
      //   ) {
      //     return;
      //   }
      //   this.zoomEventTime = d3.event.sourceEvent.timeStamp;
      window.callGraphListeners("zoom", {
        // e: d3.event,
        uid: this.uid,
        width: this.width,
      });
    };

    const brushTrigger = () => {
      if (!this.active) return;
      //   if (d3.event.sourceEvent && d3.event.sourceEvent.type === "zoom") return; // ignore brush-by-zoom
      //   if (
      //     !d3.event.sourceEvent ||
      //     this.brushEventTime === d3.event.sourceEvent.timeStamp
      //   ) {
      //     return;
      //   }
      //   this.brushEventTime = d3.event.sourceEvent.timeStamp;
      //   this.selection = d3.event.selection;
      //   window.callGraphListeners("brush", {
      //     e: d3.event,
      //     uid: this.uid,
      //     width: this.width,
      //   });
    };

    this.brush = d3
      .brushX()
      .extent([
        [0, 0],
        [this.width, this.height2],
      ])
      .on("brush end", brushTrigger);

    this.zoom = d3
      .zoom()
      .scaleExtent([1, Infinity])
      .translateExtent([
        [0, 0],
        [this.width, this.height],
      ])
      .extent([
        [0, 0],
        [this.width, this.height],
      ])
      .on("zoom", zoomTrigger);

    this.area = d3
      .line()
      .x((d) => {
        return this.x(d.time);
      })
      .y((d) => {
        return this.y(d.value);
      })
      .curve(d3.curveMonotoneX);

    this.areaY2 = d3
      .line()
      .x((d) => {
        return this.x(d.time);
      })
      .y((d) => {
        return this.ya2(d.value);
      })
      .curve(d3.curveMonotoneX);

    // this.area2 = d3.area()
    this.area2 = d3
      .line()
      .x((d) => {
        return this.x2(d.time);
      })
      // .y0(this.height2)
      .y((d) => {
        return this.y2(d.value);
      })
      .curve(d3.curveMonotoneX);

    let x;
    const mouseoverTrigger = (X = null) => {
      if (X) {
        x = X;
      } else {
        x =
          //   d3.event.offsetX -
          this.props.config.type === "controller"
            ? this.margin2.left
            : this.margin.left;
      }
      if (x > 0 && x < this.width) {
        window.callGraphListeners("mouseover", {
          x,
          width: this.width,
          time: this.x.invert(x),
          selection: this.selection || [0, this.width],
          source: this.props.config.type,
          broadcast: X === null,
        });
      }
    };

    const mouseoverTriggerListener = (time) => {
      mouseoverTrigger(this.x(time));
    };

    if (this.props.data.controller) {
      window.setGraphTimeline = mouseoverTriggerListener;
    }

    this.svg.on("mousemove", () => {
      mouseoverTrigger();
    });

    for (let idx = 0; idx < this.props.data.config.length; idx++) {
      if (window["inGraph-" + this.props.data.key + "-" + idx]) {
        this.draw(...window["inGraph-" + this.props.data.key + "-" + idx]);
      } else {
        // this.draw([],idx,0,0);
      }
    }
  }

  componentDidMount() {
    if (this.props.forwardedRef) {
      this.props.forwardedRef.current = this.divRef.current;
    }
    if (!this.props.data.staticHandler) {
      this.init(this.refs.svg);
    }
  }

  draw(data, index, reqTime, priority, svg = null, config = {}) {
    if (svg) {
      this.svg = d3.select(svg);
    }

    this.props.data.config[0] = { ...this.props.data.config[0], ...config };

    if (
      this.dataStat[index] &&
      this.dataStat[index].reqTime !== reqTime &&
      this.dataStat[index].priority < priority
    ) {
      return;
    }

    this.dataStat[index] = { reqTime, priority };
    this.data[index] = data;
    window["inGraph-" + this.props.data.key + "-" + index] = [
      data,
      index,
      reqTime,
      priority,
    ];

    if (
      (this.data[0] && this.data[0].length) ||
      (this.data[1] && this.data[1].length)
    ) {
      this.setState({ noData: false });
    } else {
      this.setState({ noData: true });
    }

    this.setBusy(false);
    if (index === 0) {
      this.svg.selectAll("*").remove();
      this.defs = this.svg.append("defs");
      this.defs
        .append("clipPath")
        .attr("id", "clip-" + this.uid)
        .append("rect")
        .attr("width", this.width)
        .attr(
          "height",
          this.props.config.type === "controller" ? this.height2 : this.height
        );

      this.pathgrad = this.defs
        .append("linearGradient")
        .attr("id", "pathgrad")
        .attr("x1", "50%")
        .attr("y1", "100%")
        .attr("x2", "50%")
        .attr("y2", "0%");

      this.pathgrad
        .append("stop")
        .attr("offset", "0%")
        .attr("style", "stop-color:rgb(153,218,255);stop-opacity:1");

      this.pathgrad
        .append("stop")
        .attr("offset", "100%")
        .attr("style", "stop-color:rgb(0,255,60);stop-opacity:1");

      let mar =
        this.props.config.type === "controller" ? this.margin2 : this.margin;

      this.focus = this.svg
        .append("g")
        .attr("class", "focus")
        .attr("transform", "translate(" + mar.left + "," + mar.top + ")");

      this.Context = this.svg
        .append("g")
        .attr("class", "context")
        .attr(
          "transform",
          "translate(" + this.margin2.left + "," + this.margin2.top + ")"
        );

      this.pointerLine = this.focus
        .append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("clip-path", "url(#clip-" + this.uid + ")")
        .attr("width", 2)
        .attr("class", "pointerLine")
        .attr(
          "height",
          this.props.config.type === "controller" ? this.height2 : this.height
        )
        .attr("fill", "rgba(255,100,100,0.5)");
    }

    const getDomainValues = (config, data) => {
      let low = config.normalize
        ? d3.min(data, (d) => {
            return d.value;
          })
        : 0;
      let high = d3.max(data, (d) => {
        return d.value;
      });
      return [low, high + (high - low) * 0.5];
    };

    this.x.domain(
      d3.extent(data, (d) => {
        return d.time;
      })
    );
    if (index === 0) {
      this.y.domain(getDomainValues(this.props.data.config[index], data));
    } else {
      this.ya2.domain(getDomainValues(this.props.data.config[index], data));
    }
    this.x2.domain(this.x.domain());
    this.y2.domain(this.y.domain());

    if (this.props.config.type === "controller") {
      if (index === 0) {
        this.Context.append("path")
          .data([data])
          .attr("stroke", this.getStroke(index))
          .attr("stroke-width", "2px")
          .attr("class", "area")
          .attr("d", this.area2);
        this.Context.append("g")
          .attr("class", "axis axis--x")
          .attr("transform", "translate(0," + this.height2 + ")")
          .call(this.xAxis2);

        if (!this.props.data.staticHandler) {
          this.Context.append("g")
            .attr("class", "brush")
            .call(this.brush)
            .call(this.brush.move, this.x.range());
        }
      }
    } else {
      if (!this.focus) return;

      if (index === 0) {
        this.focus
          .append("path")
          .data([data])
          .attr("stroke", this.getStroke(index))
          .attr("stroke-width", "2px")
          .attr("class", "area")
          .attr("clip-path", "url(#clip-" + this.uid + ")")
          .attr("d", this.area);

        this.focus
          .append("g")
          .attr("class", "axis axis--x")
          .attr("transform", "translate(0," + this.height + ")")
          .call(this.xAxis);

        this.focus.append("g").attr("class", "axis axis--y").call(this.yAxis);

        this["pointerText" + index] = this.focus
          .append("text")
          .attr("x", 10)
          .attr("y", this.props.data.staticHandler ? 12 : 10)
          .attr("font-size", 10)
          .attr("font-family", "gotham-b")
          .attr("fill", this.props.data.config[index].color || "#6da7ff")
          .text(this.props.data.config[index].name);
        if (this.props.data.displayMax) {
          this.focus
            .append("text")
            .attr("x", this.width / 2)
            .attr("y", this.props.data.staticHandler ? 12 : 10)
            .attr("text-anchor", "middle")
            .attr("font-size", 10)
            .attr("font-family", "gotham-b")
            .attr("fill", this.props.data.config[index].color || "#6da7ff")
            .text(
              "Max: " +
                parseFloat(
                  (
                    d3.max(
                      data,
                      (d) => {
                        return d.value;
                      },
                      10
                    ) || 0.0
                  ).toFixed(2)
                )
            );
        }
        if (this.props.data.displayTime) {
          this["timeText" + index] = this.focus
            .append("text")
            .attr("x", this.width - 10)
            .attr("text-anchor", "end")
            .attr("y", this.props.data.staticHandler ? 12 : 10)
            .attr("font-size", 10)
            .attr("font-family", "gotham-b")
            .attr("fill", this.props.data.config[index].color || "#6da7ff")
            .text("TIME");
        }

        this.svg
          .append("rect")
          .attr("class", "zoom")
          .attr("width", this.width)
          .attr("height", this.height)
          .attr(
            "transform",
            "translate(" + this.margin.left + "," + this.margin.top + ")"
          )
          .call(this.zoom);
      } else {
        this.focus
          .append("path")
          .data([data])
          .attr("stroke", this.getStroke(index))
          .attr("stroke-width", "2px")
          .attr("class", "area area2")
          .attr("clip-path", "url(#clip-" + this.uid + ")")
          .attr("d", this.areaY2);

        this["pointerText" + index] = this.focus
          .append("text")
          .attr("x", 10)
          .attr("y", 25)
          .attr("font-size", 10)
          .attr("font-family", "gotham-b")
          .attr("fill", this.props.data.config[index].color || "#6da7ff")
          .text(this.props.data.config[index].name);

        this.focus
          .append("g")
          .attr("class", "axis axis--y")
          .attr("transform", "translate(" + this.width + ",0)")
          .call(this.yAxis2);
      }
    }

    this.active = true;
  }

  render() {
    if (this.props.data.staticHandler) {
      return <span></span>;
    }
    return (
      <div className="InGraph" ref={this.divRef}>
        {this.state.noData ? <div className="ig-noData">No Data</div> : null}
        <div className="zoomBlocker"></div>
        {this.state.busy ? (
          <div className="ig-busy">
            <span className="igb-spinner"></span>
          </div>
        ) : null}
        <svg
          ref="svg"
          width={this.props.config.width}
          height={this.props.config.height}
        ></svg>
      </div>
    );
  }

  initSVG() {
    if (this.refs.svg) {
      this.svg = d3.select(this.refs.svg);
      this.svg.on("contextmenu", (event) => {
        event.preventDefault();
      });
    }
  }

  broadCastMouseOverEvent(event) {
    let graphOffset = graphOffsetKey;
    if (event[graphOffsetKey + "X"] == undefined) {
      if (graphOffsetKey == "layer") {
        graphOffset = "offset";
      } else {
        graphOffset = "layer";
      }
    }
    window.callInGraph2Listeners(
      "mouseover",
      {
        x: event[graphOffset + "X"] - this.margin.left,
        source: event.source,
        key: this.props.data.key,
        time: this.xDomain.invert(event[graphOffset + "X"] - this.margin.left),
        width: this.width,
      },
      this.props.data.graphSetName
    );
  }

  mouseOverTrigger(event) {
    if (!event) return;

    if (this.isMouseDownValid(event)) {
      this.calculateZoomValues(event);
      if (!this.mouseDown.rect) {
        this.initiateZoomRect();
      } else {
        this.updateZoomRect();
      }
    } else {
      this.clearZoomRect();
    }
    if (!this.mouseDown && !this.pointerLocked) {
      this.broadCastMouseOverEvent(event);
    }
  }

  addListenerToGraph() {
    if (this.svg) {
      const parentThis = this;
      this.svg
        .append("rect")
        .attr("class", "zoom")
        .attr("width", this.width)
        .attr("height", this.height)
        .attr(
          "transform",
          "translate(" + this.margin.left + "," + this.margin.top + ")"
        )
        .on("mousemove", (event) => {
          if (parentThis.state.tooltip) {
            const [x, y] = d3.pointer(event);
            parentThis.state.tooltip
              .style("left", x + "px")
              .style("top", y + "px");
          }
          parentThis.mouseOverTrigger(event);
        })
        .on("mouseout", (event) => {
          if (parentThis.state.tooltip) {
            parentThis.state.tooltip.style("opacity", 0);
          }
        })
        .on("mouseover", (event) => {
          if (parentThis.state.tooltip) {
            parentThis.state.tooltip.style("opacity", 1);
          }
        })
        .on("mousedown", (event) => {
          this.mouseDown = true;
          this.mouseDownX = event.offsetX;
          this.mouseDownY = event.offsetY;
        })
        .on("mouseup", (event) => {
          this.mouseDown = false;
          this.mouseDownX = null;
          this.mouseDownY = null;
        })
        .on("mouseleave", (event) => {
          this.mouseDown = false;
          this.mouseDownX = null;
          this.mouseDownY = null;
        })
        .on("click", (event) => {
          if (this.props.onClick) {
            this.props.onClick(event);
          }
        });
    }
  }
}

const MapPropsToState = (state) => {
  return {};
};

// export default connect(MapPropsToState, null, null, { withRef: true })(InGraph);
// const ForwardedInGraph = React.forwardRef((props, ref) => {
//   console.log("🔍 forwardRef wrapping InGraph. Received ref:", ref);
//   return <InGraph {...props} forwardedRef={ref} />;
// });

const ForwardedInGraph = React.forwardRef((props, ref) => {
  return <InGraph {...props} ref={ref} />;
});


export default ForwardedInGraph;
